"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getDomainAndLanguage = function getDomainAndLanguage(_ref) {
  var host = _ref.host;
  var hostWithoutWww = host.replace("www.", "");
  var language = global.__appConfig__.domainLanguages[hostWithoutWww];
  var domain = Object.keys(global.__appConfig__.domainLanguages).find(function (key) {
    return key === hostWithoutWww;
  });
  if (!language || !domain) {
    console.error("Error configuration with language and domain: ".concat(language, " ").concat(domain, ", host: ").concat(host, ", ").concat(JSON.stringify(global.__appConfig__.domainLanguages)));
    return {
      error: true
    };
  }
  return {
    language: language,
    domain: domain,
    host: hostWithoutWww
  };
};
var _default = getDomainAndLanguage;
exports["default"] = _default;